export const environment = {
  apiUrl: 'https://atbum0ewag.execute-api.eu-west-3.amazonaws.com/v1/',
  label: 'Recette',
  auth: {
    authority: 'https://cognito-idp.eu-west-3.amazonaws.com/eu-west-3_HJ3ozgdZ0',
    redirectUrl: globalThis.location.origin,
    clientId: '6ahs1b4qvfnu826evvd12u02l1',
    scope: 'openid',
    responseType: 'code',
    logoutUrl: 'https://sunleon-rec-user-pool-app.auth.eu-west-3.amazoncognito.com/logout'
  },
  sharePoint: {
    clientId: 'afa4279a-b762-41e5-b367-25f87eb017c3',
    tenantId: 'f48f023f-f1f2-4a42-92aa-bebb215f31d0',
    siteUrl: 'https://workplaceenergy.sharepoint.com/sites/VCI-PRProjets',
    defaultFolderPath: 'Documents partages/01_PROJETS'
  }
};
